const { linearScale } = require('styled-system-scale')

const sizes = {
  small: '48rem',
  medium: '60rem',
  large: '85rem',
  xlarge: '120rem',
}
const breakpoints = Object.values(sizes)

// Used for linearScale count
const count = breakpoints.length + 1

const theme = {
  /***
   * Sizes
   */
  breakpoints,
  sizes,

  /***
   * Colors
   */
  colors: {
    white: '#fff',
    black: '#000',
    gray: {
      20: '#323539',
      50: '#80858E',
      60: '#A5A8AC',
      80: '#e2e2e2',
      90: '#F9F7F9',
    },
    purple: {
      50: '#863DC2',
      '50-2': '#8359a6',
      90: '#EEE9EF',
      '90-2': '#F4F0F0',
      100: '#F9F7F9',
    },
    red: {
      50: '#E12D39',
      90: '#FFF3F3',
    },
    yellow: {
      50: '#F3B75E',
      60: '#F7C948',
      90: '#FFFBEA',
    },
    blue: {
      50: '#427EC6',
      90: '#F5F7FB',
    },
    orange: {
      50: '#E47d12',
    },
  },

  /***
   * Fonts
   */
  fonts: {
    sans: '"Inter var", system-ui',
  },
  fontSizeScales: {
    t: linearScale('10px', '12px', { count }),
    s: linearScale('12px', '14px', { count }),
    'b-': linearScale('13px', '16px', { count }),
    b: linearScale('14px', '18px', { count }),
    'b+': linearScale('17px', '19px', { count }),
    'm-': linearScale('17px', '24px', { count }),
    m: linearScale('17px', '28px', { count }),
    l: linearScale('20px', '36px', { count }),
    xl: linearScale('24px', '42px', { count }),
    xxl: linearScale('36px', '80px', { count }),
  },
  fontWeights: {
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800,
  },
  lineHeights: {
    solid: 1,
    title: 1.15,
    titleLoose: 1.35,
    copyTight: 1.5,
    copy: 1.65,
  },

  /***
   * Spacing
   */
  spaceScales: {
    0: linearScale(0, 0, { count }),
    't-': linearScale('5px', '8px', { count }),
    t: linearScale('10px', '12px', { count }),
    s: linearScale('14px', '17px', { count }),
    'm-': linearScale('16px', '24px', { count }),
    m: linearScale('16px', '32px', { count }),
    l: linearScale('18px', '40px', { count }),
    xl: linearScale('20px', '50px', { count }),
    xxl: linearScale('30px', '65px', { count }),
    h: linearScale('65px', '120px', { count }),
  },

  /***
   * Transitions
   */
  transitionDurations: {
    slow: '300ms',
    normal: '200ms',
    fast: '100ms',
  },

  /***
   * Variants
   */
  textStyles: {
    caps: {
      textTransform: 'uppercase',
    },
    trackedCaps: {
      textTransform: 'uppercase',
      letterSpacing: '0.075em',
    },
    lowercase: {
      textTransform: 'lowercase',
    },
    capitalize: {
      textTransform: 'capitalize',
    },
  },
  boxStyles: {
    lastNoMargin: {
      '&:last-child': {
        marginBottom: 0,
        marginRight: 0,
      },
    },
    firstLastNoMargin: {
      '&:first-child': {
        marginTop: 0,
        marginLeft: 0,
      },
      '&:last-child': {
        marginBottom: 0,
        marginRight: 0,
      },
    },
  },

  /***
   * Media queries
   */
  mediaQueries: Object.keys(sizes).reduce((acc, key) => {
    acc[key] = `@media screen and (min-width: ${sizes[key]})`

    return acc
  }, {}),
}

exports.theme = theme
